import React from 'react';
import styles from './styles.module.scss';
import { formatCurrency } from '@wolffun/system-currency';
import icThg from '/assets/img/thetan_gem_V2.png';

const VestingSafeInfo = ({
  minPaid,
  maxPaid,
  paidPercent
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.vestingInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "THG Vested/day")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, `${paidPercent ? paidPercent.toFixed(2) : 0} %`))), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Min THG vested/day")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, minPaid ? formatCurrency(minPaid, {
    trimWholeFraction: true
  }) : 0), /*#__PURE__*/React.createElement("img", {
    src: icThg,
    alt: ""
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Max THG vested/day")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, maxPaid ? formatCurrency(maxPaid, {
    trimWholeFraction: true
  }) : 0), /*#__PURE__*/React.createElement("img", {
    src: icThg,
    alt: ""
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, /*#__PURE__*/React.createElement("span", null, "THG earned from in-game activities is stored in Vesting Safe. The Safe releases, on a daily basis, a certain amount of THG depending on the current balance and min/max thresholds stated above. The thresholds vary with the account's credibility.")));
};

export default VestingSafeInfo;